<app-header></app-header>
<app-home-navbar></app-home-navbar> 
<router-outlet (activate)="onActivate()" ></router-outlet>
<app-footer></app-footer>